import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";
import { useAuth } from "../context/AuthContext";
import "./Profile.css";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "—"; }
}

export default function Profile() {
  const { user: authUser, logout } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/user/profile")
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="pf-loading"><div className="pf-spinner" />Loading profile…</div>;
  }

  const user = (data && data.user) || authUser || {};
  const s = (data && data.stats) || {};
  const initial = (user.fname || user.email || "U").trim().charAt(0).toUpperCase();
  const isReseller = user.reseller === "yes";

  const stats = [
    { label: "Wallet Balance", value: inr(s.walletBalance), accent: "teal" },
    { label: "Topup Orders", value: s.topupOrders ?? 0, accent: "blue" },
    { label: "Wallet Orders", value: s.walletOrders ?? 0, accent: "purple" },
    { label: "UPI Orders", value: s.upiOrders ?? 0, accent: "blue" },
    { label: "Success Orders", value: s.successOrders ?? 0, accent: "green" },
    { label: "Pending Orders", value: s.pendingOrders ?? 0, accent: "orange" },
    { label: "Needs Review", value: s.needsReview ?? 0, accent: "orange" },
    { label: "Refunded Orders", value: s.refundedOrders ?? 0, accent: "red" },
  ];

  return (
    <div className="pf">
      <div className="pf-card">
        <div className="pf-head">
          <div className="pf-avatar">{initial}</div>
          <span className={`pf-tier ${isReseller ? "on" : ""}`}>
            {isReseller ? "★ Reseller" : "Member"}
          </span>
        </div>

        <h1 className="pf-name">{user.fname || "NovaStore User"}</h1>
        <div className="pf-contact">
          {user.mobile && <span>{user.mobile}</span>}
          <span>{user.email}</span>
        </div>

        {isReseller && <div className="pf-badge-line">✓ Reseller pricing applied</div>}
        <div className="pf-since">Member since {fmtDate(user.createdAt)}</div>

        <div className="pf-grid">
          {stats.map((st) => (
            <div key={st.label} className={`pf-stat ${st.accent}`}>
              <div className="pf-stat-val">{st.value}</div>
              <div className="pf-stat-label">{st.label}</div>
            </div>
          ))}
        </div>

        <div className="pf-actions">
          <Link to="/wallet" className="pf-btn primary">Add Money</Link>
          <Link to="/orders" className="pf-btn">My Orders</Link>
          <button className="pf-btn danger" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
}